/**
 * @author Housefolios
 * @createTime 2025-01-27 10:00:00
 * @modifiedBy AI Assistant
 * @modifiedTime 2025-01-27 10:00:00
 * @description Custom hook for common strategy page functionality
 */

import { useState } from 'react'

/**
 * Custom hook for strategy page common functionality
 * @param {Object} options - Hook options
 * @param {string} options.strategyName - Name of the strategy
 * @param {Function} [options.onToggle] - Function to handle modal toggles
 * @returns {Object} Hook state and functions
 */
export const useStrategyPage = ({
  strategyName,
  onToggle = () => {},
}) => {
  // Common modal states
  const [modal1, setModal1] = useState(null)
  const [maxOfferDescription, setMaxOfferDescription] =
    useState(false)

  // Strategy-specific tour states
  const [openStrategyTour, setOpenStrategyTour] = useState(false)
  const [openTargetsTour, setOpenTargetsTour] = useState(false)
  const [openNetProfitTour, setOpenNetProfitTour] = useState(false)
  const [openDetailsTour, setOpenDetailsTour] = useState(false)
  const [
    openComparablePropertiesTour,
    setOpenComparablePropertiesTour,
  ] = useState(false)

  // Common toggle functions
  const toggle1 = (name) => {
    setModal1(name)
  }

  const toggle1Close = () => {
    setModal1(null)
  }

  const toggleMaxOffer = () => {
    setMaxOfferDescription(!maxOfferDescription)
  }

  // Tour openers set true; closers set false (matches strategy page button/tour UX)
  const toggleStrategyTour = () => {
    setOpenStrategyTour(true)
  }

  const toggleTargetsTour = () => {
    setOpenTargetsTour(true)
  }

  const toggleNetProfitTour = () => {
    setOpenNetProfitTour(true)
  }

  const toggleDetailsTour = () => {
    setOpenDetailsTour(true)
  }

  const toggleComparablePropertiesTour = () => {
    setOpenComparablePropertiesTour(true)
  }

  const closeStrategyTour = () => {
    setOpenStrategyTour(false)
  }

  const closeTargetsTour = () => {
    setOpenTargetsTour(false)
  }

  const closeNetProfitTour = () => {
    setOpenNetProfitTour(false)
  }

  const closeDetailsTour = () => {
    setOpenDetailsTour(false)
  }

  const closeComparablePropertiesTour = () => {
    setOpenComparablePropertiesTour(false)
  }

  return {
    // Modal states
    modal1,
    maxOfferDescription,

    // Tour states
    openStrategyTour,
    openTargetsTour,
    openNetProfitTour,
    openDetailsTour,
    openComparablePropertiesTour,

    // Toggle functions
    toggle1,
    toggle1Close,
    toggleMaxOffer,
    toggleStrategyTour,
    toggleTargetsTour,
    toggleNetProfitTour,
    toggleDetailsTour,
    toggleComparablePropertiesTour,
    closeStrategyTour,
    closeTargetsTour,
    closeNetProfitTour,
    closeDetailsTour,
    closeComparablePropertiesTour,
  }
}

export default useStrategyPage
